<template>

<div class="full-page section-image" data-color="black" data-image="/static/img/raefton-back.jpg">
<div class="content">


    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card-group mb-0">
            <div class="card p-4">
              <form class="card-block">
                <h1>Login</h1>
                <!-- <p class="text-muted">Sign In to your account</p> -->
                <div class="form-group">
                  <label>Email address</label>
                  <input id="raeftonUser" v-model="user" v-on:keyup="checkEnter" type="email" class="form-control" placeholder="Enter email">
                </div>

                <div class="form-group">
                  <label>Password</label>
                  <input id="raeftonPassword" v-model="password" v-on:keyup="checkEnter" type="password" class="form-control" placeholder="Password">
                </div>

                <div class="row">
                  <div class="col-6">
                    <button type="button" v-on:click="loginSubmit" class="btn btn-success px-4">Login</button>
                  </div>
                  <div class="col-6 text-right">
                    &nbsp;
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

</div>
</div>


</template>

<script>
import router from '../../router'
import apiService from '../../services/api.service'
import config from '../../config'

import firebaseService from '../../services/firebase.service';

import Vue from 'vue'

export default {
  name: 'Login',
  data: function () {
    return {
      user: '',
      password: ''
    }
  },

  mounted () {
    console.log("login mounted");
    sessionStorage.removeItem("newRFQ");
    sessionStorage.removeItem("num_shippments");

    if(firebaseService.currentUser){
      this.$router.push('/');
    }
  },
  methods: {
    checkEnter: function (event) {
      if(event.keyCode === 13) this.loginSubmit(event);
    },
    async loginSubmit(event){
      console.log("Login Submit");
      try{
        await firebaseService.login(this.user, this.password);
        sessionStorage.setItem("refresh","true");
        sessionStorage.setItem("refreshAwarded","true");
        sessionStorage.removeItem("num_shippments");
      }catch(e){
        Vue.toasted.error("There was a problem logging in, please check your credentials.", { duration: 3500 });
        console.error(e);
      }

    }
  }
}

</script>



// WEBPACK FOOTER //
// login.vue?6d162391